import { FunctionComponent, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { resolveTheme } from '../../themes';
import { getAboutUsCopy } from './about-us-copy';

export const AboutUsText: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ className }) => {
  const { headline, paragraphs } = getAboutUsCopy(resolveTheme().id);

  return (
    <div className={twMerge('text-dark space-y-2 text-base font-medium md:space-y-4', className)}>
      <h1 className="text-xl font-bold md:text-4xl">{headline}</h1>
      {paragraphs.map((text, i) => (
        <p key={i}>{text}</p>
      ))}
    </div>
  );
};
